import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createstudent,
  getstudent,
  deletestudents,
} from "../../ReduxToolkit/Slice/Student/Student";

import JoditEditor from "jodit-react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Button from "../../components/Button/Button";
import PageTitle from "../../components/Title/PageTitle";
import Input from "../../components/Input/Input";
import Table from "../../components/Table/Table";

function Student() {
  const dispatch = useDispatch();
  const closeButtonRef = useRef(null);
  const editor = useRef(null);

  const { status, students } = useSelector((state) => state.student);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [pdf, setPdf] = useState(null);

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    // validation
    if (!title.trim()) {
      toast.error("Title is required");
      return;
    }

    if (!pdf) {
      toast.error("Please select a PDF file");
      return;
    }

    if (!description || description === "<p><br></p>") {
      toast.error("Description is required");
      return;
    }

    // file type validation
    if (pdf.type !== "application/pdf") {
      toast.error("Only PDF files are allowed");
      return;
    }

    const data = new FormData();
    data.append("title", title);
    data.append("description", description);
    data.append("Pdf", pdf);

    try {
      await dispatch(createstudent(data));

      // close modal
      closeButtonRef.current.click();

      // reset form
      setTitle("");
      setDescription("");
      setPdf(null);

      toast.success("PDF uploaded successfully");

    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  // ================= GET DATA =================
  useEffect(() => {
    if (status === "idle") {
      dispatch(getstudent());
    }
  }, [dispatch, status]);

  // ================= DELETE =================
  const handleDelete = (studentid) => {
    const isConfirmed = window.confirm(
      "Are you sure! you want delete this Pdf?"
    );
    if (isConfirmed) {
      dispatch(deletestudents(studentid));
    }
  };

  // ================= FORMAT DATE =================
  function formatDate(dateString) {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  }

  // ================= TABLE COLUMNS =================
  const columns = [
    { label: "S.no", accessor: "serialNumber" },
    { label: "Title", accessor: "title" },

    // HTML render
    {
      label: "Description",
      accessor: "description",
      formatter: (value) => (
        <div
          dangerouslySetInnerHTML={{ __html: value }}
          style={{ maxWidth: "250px", maxHeight: "80px", overflow: "hidden" }}
        />
      ),
    },

    // PDF VIEW BUTTON
    {
      label: "PDF",
      accessor: "Pdf",
      formatter: (value) => (
        <a href={value} target="_blank" rel="noopener noreferrer">
          View
        </a>
      ),
    },

    { label: "Date", accessor: "createdAt", formatter: formatDate },
  ];

  return (
    <>
      <div>
        <ToastContainer />

        <div className="d-flex justify-content-between my-3">
          <PageTitle children={"Students Study Material"} />

          <Button
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            children={"Upload Material"}
            icon="plus-circle-fill"
          />
        </div>

        <Table
          columns={columns}
          data={students?.data || []}
          status={status}
          onDelete={handleDelete}
        />
      </div>

      {/* ================= MODAL ================= */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Upload Study Material</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">
              <form onSubmit={handleSubmit}>

                {/* TITLE */}
                <Input
                  label="Title"
                  type="text"
                  value={title}
                  required
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter title"
                />

                {/* JODIT EDITOR */}
                <div className="mb-3">
                  <label className="form-label">Description</label>

                  <JoditEditor
                    ref={editor}
                    value={description}
                    config={{
                      height: 300,
                      readonly: false,
                    }}
                    onChange={(newContent) =>
                      setDescription(newContent)
                    }
                  />
                </div>

                {/* PDF INPUT */}
                <Input
                  label="Select PDF"
                  type="file"
                  required
                  onChange={(e) => setPdf(e.target.files[0])}
                />

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                    ref={closeButtonRef}
                  >
                    Close
                  </button>

                  <Button type="submit" children={"Upload"} />
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Student;